import { orderBy } from 'lodash';

export const getTagsValue = (formValue) => {
    return orderBy(formValue, (o) => o.name.toLowerCase());
};

export const filterValueResolverByKey = {
    tags: (formValue) => getTagsValue(formValue),
    progressMeasurement: (formValue, storeValue) => formValue || storeValue,
};
